const RAW = (import.meta.env.VITE_BOOKING_SERVICE_URL || '').replace(/\/$/, '');

function isLocalBookingHost(url: string): boolean {
  return /localhost|127\.0\.0\.1|\[::1\]/.test(url);
}

/**
 * Browser-safe base for booking-service requests.
 * In dev, route localhost targets through Vite proxy to avoid Mini App/ngrok CORS failures.
 */
export function getBookingBrowserBase(): string {
  if (!RAW) {
    return import.meta.env.DEV ? '/__booking_dev__' : '';
  }
  if (import.meta.env.DEV && isLocalBookingHost(RAW)) {
    return '/__booking_dev__';
  }
  return RAW;
}
